<script lang="ts">
    import type {Row} from '@tanstack/svelte-table';
    import type {HierarchicalRecordRow} from 'src/features/record-grid/lib/types';
    import type {RecordGridDataManager} from 'src/features/record-grid/lib/record-grid-data-manager';
    import {getProjectReportOptimisationContext} from '../project-report-optimisation-context';
    import {FOND_PROJECT_BUSINESS_ITEM} from 'src/features/erp-sutor/sutor-fonds';
    import DefaultRowOptionsCell from 'src/features/record-grid/components/cells/DefaultRowOptionsCell.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import Spacer from 'shared/layouts/flex/Spacer.svelte';

    export let recordGridDataManager: RecordGridDataManager;
    export let row: Row<HierarchicalRecordRow>;

    const context = getProjectReportOptimisationContext();

    const handleOptimiseClick = () => {
        context.setOptimisedBusinessItemRecord(row.original);
    };

    const handleOpenOverviewClick = () => {
        context.setOpenOverviewSignal(row.original);
    };
</script>

<DefaultRowOptionsCell {recordGridDataManager} {row}>
    <Spacer flex="1"/>

    {#if FOND_PROJECT_BUSINESS_ITEM.subfonds.includes(row.original.fond.id) && !row.original.draft}
        <KpButton buttonSize="xs" buttonStyle="brand-orange-new" on:click={handleOptimiseClick}>
            <IconedContent icon="user-add">Optimalizovat</IconedContent>
        </KpButton>

        <KpButton buttonSize="xs" on:click={handleOpenOverviewClick}>
            <IconedContent icon="chart-histogram">Přehled</IconedContent>
        </KpButton>
    {/if}
</DefaultRowOptionsCell>